import { CommonModule } from '@angular/common';
import { Component, inject, OnInit, signal } from '@angular/core';
import { DesyAngularModule } from 'desy-angular';
import { HomeCardComponent } from '@/app/shared/cards/home-card/home-card.component';
import { UserAnjana } from '@/app/interfaces/UserAnjana';
import { LoginService } from '@/app/services/login.service';
import { uppercaseFirstPipe } from '@/app/pipe/uppercaseFirstPipe.pipe';
import { HomeService } from '@/app/services/home.service';
//import { OrganismosTreeComponent } from '@/app/shared/organismos-tree/organismos-tree.component';

@Component({
  selector: 'app-home',
  imports: [HomeCardComponent, DesyAngularModule, CommonModule, uppercaseFirstPipe], // OrganismosTreeComponent
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss',
  standalone: true,
})
export class HomeComponent implements OnInit {
  accessionsSent = signal([
    {
      title: 'Pendientes',
      count: 0,
      url: '/mis-adhesiones/listado/enviadas',
      textUrl: 'Ver mis adhesiones pendientes',
      state: 'pending', // ← mantengo tu string tal cual
      description: 'Adhesiones pendientes',
    },
    {
      title: 'Aprobadas',
      count: 0,
      url: '/mis-adhesiones/listado/enviadas',
      textUrl: 'Ver mis adhesiones aprobadas',
      state: 'approved',
      description: 'Adhesiones aprobadas',
    },
    {
      title: 'Rechazadas',
      count: 0,
      url: '/mis-adhesiones/listado/enviadas',
      textUrl: 'Ver mis adhesiones rechazadas',
      state: 'rejected',
      description: 'Adhesiones rechazadas',
    },
    {
      title: 'Finalizadas',
      count: 0,
      url: '/mis-adhesiones/listado/enviadas',
      textUrl: 'Ver mis adhesiones finalizadas',
      state: 'finished',
      description: 'Adhesiones finalizadas',
    },
    {
      title: 'Bloqueadas',
      count: 0,
      url: '/mis-adhesiones/listado/enviadas',
      textUrl: 'Ver mis adhesiones bloqueadas',
      state: 'blocked',
      description: 'Adhesiones bloqueadas',
    },
  ]);
  accessionsRequested = signal([
    {
      title: 'Pendientes',
      count: 0,
      url: '/mis-adhesiones/listado/recibidas',
      textUrl: 'Ver mis adhesiones pendientes',
      state: 'pending', // ← mantengo tu string tal cual
      description: 'Adhesiones pendientes',
    },
    {
      title: 'Aprobadas',
      count: 0,
      url: '/mis-adhesiones/listado/recibidas',
      textUrl: 'Ver mis adhesiones aprobadas',
      state: 'approved',
      description: 'Adhesiones aprobadas',
    },
    {
      title: 'Rechazadas',
      count: 0,
      url: '/mis-adhesiones/listado/recibidas',
      textUrl: 'Ver mis adhesiones rechazadas',
      state: 'rejected',
      description: 'Adhesiones rechazadas',
    },
    {
      title: 'Finalizadas',
      count: 0,
      url: '/mis-adhesiones/listado/recibidas',
      textUrl: 'Ver mis adhesiones finalizadas',
      state: 'finished',
      description: 'Adhesiones finalizadas',
    },
    {
      title: 'Bloqueadas',
      count: 0,
      url: '/mis-adhesiones/listado/recibidas',
      textUrl: 'Ver mis adhesiones bloqueadas',
      state: 'blocked',
      description: 'Adhesiones bloqueadas',
    },
  ]);
  currentUser: Partial<UserAnjana> | null = null;
  fullName: string = '';
  private loginService = inject(LoginService);
  constructor(private homeService: HomeService) {}
  async ngOnInit() {
    this.currentUser = await this.loginService.getCurrentUser();

    const loggedUserData = JSON.parse(localStorage.getItem('userData') || '{}');
    const hasDpdRole = loggedUserData?.roles?.dpd ? true : false;

    const data = await this.homeService.getHome(hasDpdRole);
    if (data?.data?.length) {
      if (data.data[0]?.length) {
        data.data[0].forEach((e) => {
          this.accessionsSent.update((items) =>
            items.map((el) =>
              el.state === e.estado.toLowerCase() ? { ...el, count: e.total_adhesiones_enviadas } : el
            )
          );
        });
      }
      if (data.data[1]?.length) {
        data.data[1].forEach((e) => {
          this.accessionsRequested.update((items) =>
            items.map((el) =>
              el.state === e.estado.toLowerCase() ? { ...el, count: e.total_adhesiones_recibidas } : el
            )
          );
        });
      }
    }
    if (this.currentUser) {
      this.fullName = this.currentUser.givenName + ' ' + this.currentUser.surname1 + ' ' + this.currentUser.surname2;
    }
  }
}
